import React from 'react';
import { useTranslation } from 'react-i18next';

interface ContextualTooltipProps {
    isVisible: boolean;
    onDismiss?: () => void;
}

const ContextualTooltip: React.FC<ContextualTooltipProps> = ({ isVisible, onDismiss }) => {
    const { t } = useTranslation();
    if (!isVisible) return null;

    return (
        <div className="absolute z-50 -top-12 left-1/2 transform -translate-x-1/2 
                    bg-emerald-600/95 backdrop-blur-md text-white px-3 py-1.5 rounded-xl shadow-lg border border-emerald-500/50
                    animate-bounce cursor-pointer flex items-center gap-2 whitespace-nowrap"
            onClick={(e) => { e.stopPropagation(); onDismiss?.(); }}>
            <span className="text-2xs font-black uppercase tracking-wider">{t('gamification.tooltip.log_first')}</span>
            <div className="absolute -bottom-1.5 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-emerald-600/95 rotate-45 border-r border-b border-emerald-500/50" />
        </div>
    );
};
export default ContextualTooltip;
